import axios from 'axios';

const API = axios.create({ baseURL: `https://${process.env.NODE_ENV ==="development"?"localhost":"brandbuddyar.com"}:8080` });
{/*
API.interceptors.request.use((req) => {
  if (localStorage.getItem('profile')) {
    req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
  }

  return req;
});
*/}
export const experienceGet = (formData) => API.post('/experiences/experiencegetar', formData);
export const experienceTextureGet = (url) => API.get('/experiences/image/'+url).then((res) => {
return res});